import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { OrderListModule } from 'primeng/orderlist';
import { Popover } from 'primeng/popover';

@Component({
    selector: 'st-multi-select-draggable',
    imports: [
        CommonModule,
        Popover,
        CheckboxModule,
        OrderListModule,
        FormsModule,
        ButtonModule,
    ],
    templateUrl: './multi-select-draggable.component.html',
    styleUrl: './multi-select-draggable.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelectDraggableComponent {
  items = input.required<any[]>();
  optionLabel = input.required<string>();
  itemsModel = model.required<any[]>();
  selectedItem: any[] = [];
  isSelectionChange = signal(false);

  constructor() {
    effect(
      () => {
        const currentItems = this.items();
        if (currentItems?.length) {
          this.selectedItem = [...currentItems];
          this.itemsModel.set(this.selectedItem);
          this.isSelectionChange.set(false);
        }
      },
      { allowSignalWrites: true },
    );
  }

  selectionChange() {
    this.itemsModel.set(this.selectedItem);
    this.isSelectionChange.set(
      this.selectedItem.length !== this.items().length,
    );
  }
}
